/* eslint-disable */
const path = require('path')
const fs = require('fs')
const HttpBackend = require('i18next-http-backend/cjs')
const ChainedBackend = require('i18next-chained-backend').default
const LocalStorageBackend = require('i18next-localstorage-backend').default

const isBrowser = typeof window !== 'undefined'
const isDev = process.env.NODE_ENV === 'development'

let allNS = []

try {
  if (!isBrowser) {
    const jsonFiles = fs.readdirSync(path.resolve(process.cwd(), './public/locales/zh-CN'))
    allNS = jsonFiles.map(f => path.parse(f).name)
  } else {
    const modules = require.context('./public/locales/zh-CN', true)
    const res = modules.keys().map(p => {
      const [jsonName] = p?.slice(2)?.split('.json');
      return jsonName;
    })
    allNS = Array.from(new Set([...res]));
  }
} catch (e) {
  console.log(e)
}

module.exports = {
  // debug: isDev,
  backend: {
    backendOptions: [{ expirationTime: isDev ? 60 * 1000 : 60 * 60 * 1000 }, {}], // 1 hour
    backends: isBrowser ? [LocalStorageBackend, HttpBackend] : [],
  },
  i18n: {
    defaultLocale: 'zh-CN',
    locales: ['zh-CN', 'en-US'],
  },
  initImmediate: false,
  localePath: typeof window === 'undefined' ? path.resolve('./public/locales') : '/locales',
  ns: allNS, // namespace
  partialBundledLanguages: isBrowser,
  reloadOnPrerender: process.env.NODE_ENV === 'development',
  use: isBrowser ? [ChainedBackend] : [],
}
